import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TaskService } from '@app/core/services/task.service';
import { Answer } from '@app/definitions/interfaces';
import { IExercise } from '@df/interfaces/exercise';
import { KATEX_FORMAT } from '@app/app.constants';

@Component({
    selector: 'app-exercise-calc',
    templateUrl: './exercise-calc.component.html',
    styleUrls: ['../../../../../_pipes/exercise-format.pipe.scss', './exercise-calc.component.scss']
})
export class ExerciseCalcComponent implements OnInit {
    @Input() exerIndex: number;
    @Input() exercise;
    @Input() cardId: number;
    @Input() studentId: number;
    @Input() isAuthorCard: boolean;
    @Input() isAccessCard: boolean;
    @Input() prev_results: Array<any> = [];
    @Output() answered = new EventEmitter();
    answerStr: string;

    answerCorrect: boolean;

    constructor(private taskService: TaskService) {}

    ngOnInit() {
        if (this.prev_results) {
            this.prev_results.forEach(item => {
                if (this.exercise.id === item.exercise_id) {
                    this.answerStr = item.short_answer;
                    this.answerInputChange(item.short_answer);
                }
            });
        } else {
            this.answerStr = this.exercise.answers[0].shortAnswer;
        }
        this.answerCorrect = this.taskService.checkCorrectAnswer(this.answerStr, this.exercise);
    }

    answerInputChange(event) {
        const exerciseCorrect = this.taskService.checkCorrectAnswer(this.answerStr, this.exercise);
        const answerObject: Answer = {
            student: this.studentId,
            card: this.cardId,
            exercise: this.exercise.id,
            correct: exerciseCorrect
        };

        this.answerCorrect = exerciseCorrect;

        for (const exerAnswer of this.exercise.answers) {
            if (exerciseCorrect) {
                if (
                    this.taskService.trimAnswer(this.answerStr) === this.taskService.trimAnswer(exerAnswer.shortAnswer)
                ) {
                    answerObject.shortAnswer = this.answerStr;
                } else {
                    answerObject.fullAnswer = this.answerStr;
                }
                break;
            } else {
                answerObject.shortAnswer = this.answerStr;
            }
        }

        if (event) {
            this.answered.emit(answerObject);
        }
    }

    checkCorrectStyling(): boolean {
        if (this.answerStr === '') {
            // Need for init - when answer is not defined
            return true;
        }
        if (!this.exercise.answers) {
            return true;
        }
        return this.answerCorrect;
    }

    clearAnswer(event) {
        this.answerStr = '';
        this.isEmptyAnswer(event);
    }

    isEmptyAnswer(event = false) {
        if (this.answerStr === '') {
            if (event) {
                this.answerInputChange(event);
            }
            return true;
        }
        return false;
    }

    isKatexFormat(exercise: IExercise): boolean {
        return exercise.format_type === KATEX_FORMAT;
    }
}
